import type { ValuesExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from './../types';

export const valuesResolver =
  createSimpleNamedExpressionResolver<ValuesExpression>(
    'values',
    Object.values
  );
